import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import {
  selectEditedFirestopAttributes,
  selectFirestopEditImagesToDelete,
  selectFirestopImagesToAdd,
  selectFirestopLabelsToDelete,
  selectSelectedFirestopItemIdToEdit,
} from '../selectors/firestop-documentation.selectors';
import { patchUpdateFirestopItem } from '../services/patch-update-firestop-item.service';

export const updateFirestopItem = createAsyncThunk(
  'firestopDocumentation/updateFirestopItem',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const firestopItemIdToUpdate =
      selectSelectedFirestopItemIdToEdit(getState());

    const firestopItemAttributeModifications =
      selectEditedFirestopAttributes(getState());

    const firestopImagesToAdd = selectFirestopImagesToAdd(getState());

    const firestopImagesToDelete = selectFirestopEditImagesToDelete(getState());

    const firestopLabelsToDelete = selectFirestopLabelsToDelete(getState());

    const updatedFirestopItemData = await patchUpdateFirestopItem(
      selectedProjectId,
      firestopItemIdToUpdate,
      firestopItemAttributeModifications,
      firestopImagesToAdd,
      firestopImagesToDelete,
      firestopLabelsToDelete
    );

    return updatedFirestopItemData;
  }
);
